import React from 'react';
import { STitle, SDesc, SDiv, SContent, SDotSVG } from './styles';
import PropTypes from 'prop-types';
import Button from 'components/Button';
import { Row, Col } from 'react-bootstrap';

const CTAWithText = ({
  title,
  desc,
  onClick,
  ctaText = 'Learn More',
  buttonID,
}) => {
  return (
    <SDiv>
      <SDotSVG
        left
        variant="main"
        $moveY="0"
        isSVGLine={true}
        isVisibleMobile={true}
      />
      <SContent>
        <Row className="justify-content-center align-items-center my-4">
          <Col xs="12" md="4">
            <STitle as="h3">{title}</STitle>
          </Col>
          <Col xs="12" md="5" className="my-3">
            <SDesc>{desc}</SDesc>
          </Col>
          <Col xs="12" md="3">
            <Button
              variant="full"
              $withArrow={true}
              onClick={onClick}
              buttonID={buttonID}
            >
              {ctaText || 'Learn More'}
            </Button>
          </Col>
        </Row>
      </SContent>
    </SDiv>
  );
};

CTAWithText.propTypes = {
  title: PropTypes.string,
  ctaText: PropTypes.string,
  buttonID: PropTypes.string,
  desc: PropTypes.node,
  onClick: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
};

export default CTAWithText;
